import { fetcher } from "helpers/fetcher";

import { TUpdateBUStaffNotesReq, TUpdateBUStaffNotesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateBUStaffNotes = async (payload: TUpdateBUStaffNotesReq) => {
  return await fetcher<TUpdateBUStaffNotesRes, TUpdateBUStaffNotesReq["data"]>(
    ENDPOINT.BU.UPDATE_BU_STAFF_NOTES,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.UPDATE_BU_STAFF_NOTES.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationUpdateBUStaffNotes = async (
  payload: TUpdateBUStaffNotesReq
) => {
  return (await updateBUStaffNotes(payload)).data;
};

mutationUpdateBUStaffNotes._key = (payload: TUpdateBUStaffNotesReq) => [
  ENDPOINT.BU.UPDATE_BU_STAFF_NOTES.url,
  payload,
];
